import { useState, useEffect, useCallback } from 'react';

const API_BASE = 'https://api.cloudnine.biz.id';

/**
 * Custom hook untuk mengambil dan mengelola data ras dari API
 * 
 * @returns {Object} { races, loading, error, refetch, addRace }
 */
export const useRaces = () => {
    const [races, setRaces] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchRaces = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_BASE}/races.php`);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                setRaces(result.data || []);
            } else {
                throw new Error(result.error || 'Failed to fetch races');
            }
        } catch (err) {
            setError(err.message);
            console.error('Error fetching races:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    /**
     * Tambah ras baru via API
     * @param {string} name - Nama ras
     * @returns {Object|null} Ras yang baru dibuat
     */
    const addRace = async (name) => {
        try {
            const response = await fetch(`${API_BASE}/races.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name }),
            });

            const result = await response.json();

            if (result.success) {
                await fetchRaces();
                return result.data;
            } else {
                throw new Error(result.error || 'Failed to add race');
            }
        } catch (err) {
            // Return error instead of setting global error state
            console.error('Error adding race:', err);
            return { error: err.message };
        }
    };

    useEffect(() => {
        fetchRaces();
    }, [fetchRaces]);

    return {
        races,
        loading,
        error,
        refetch: fetchRaces,
        addRace,
    };
};
